import {observable, runInAction} from "mobx";
import api from "../Services/Api";
import productFolderListStore from "./ProductFolderListStore";

class TemplateByFoldersStore {
    @observable trySave: boolean = false;
    @observable useForChildren: boolean = false;
    @observable folders: string[] = [];
    @observable templateId: string = '';
    async save() {
        if (!this.trySave) {
            this.trySave = true;
        }

        if (!this.canSave) {
            return;
        }

        this.trySave = false;

        const result = await api.post('productFolder/save', {
            productFolders: this.folders,
            templateId: this.templateId,
            useForChildren: this.useForChildren
        });
        if (result.success) {
            runInAction(() => {
                void productFolderListStore.load();
                this.folders = [];
                this.templateId = '';
                this.useForChildren = false;
            })
        }
    }

    get canSave() {
        if (!this.folders) {
            return false;
        }

        if (this.folders.length === 0) {
            return false;
        }

        if (!this.templateId) {
            return false;
        }

        return true;
    }

    async remove(productFolderId: string) {
        const result = await api.post('productFolder/removeTemplate', {
            productFolderId: productFolderId
        });
        if (result.success) {
            await productFolderListStore.load();
        }
    }
    
    setUseForChildren(value: boolean) {
        this.useForChildren = value;
    }
}

const templateByFoldersStore = new TemplateByFoldersStore();
export default templateByFoldersStore;